import type { Status } from '../index.types';

export const getKindByStatus = (status: Status) => {
	switch (status) {
		case 'pending':
			return 'secondary';
		case 'success':
			return 'primary';
		case null:
			return 'secondary';
		default:
			return 'secondary';
	}
};
